/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const FileStatusSchema = z.enum(["ACTIVE", "HIDDEN", "DISAPPROVED", "DELETED"])
